(() => {
  if (window.krOrderGift) return;
  const node = document.getElementById('KrOrderGiftConfig');
  if (!node || typeof fetch !== 'function') return;
  let config, cartUrl, updateUrl;
  try {
    config = JSON.parse(node.textContent);
    cartUrl = new URL(config.cartUrl, location.href);
    updateUrl = new URL(config.updateUrl, location.href);
    if ([cartUrl, updateUrl].some(url => url.origin !== location.origin) || !/\/cart\.js$/.test(cartUrl.pathname) || !/\/cart\/update\.js$/.test(updateUrl.pathname)) return;
  } catch (_) { return; }
  const ids = new Set(config.productIds.map(String));
  const qualifies = cart => Array.isArray(cart.items) && cart.items.some(line => ids.has(String(line.product_id)) && line.quantity > 0 && line.original_line_price > 0);
  const storageKey = 'kinriot:welcome-gift:2026-09-v1', duration = 600000;
  const deadlineKey = 'KINRIOT gift deadline (UTC)', claimKey = 'KINRIOT gift claimed (UTC)';
  let deadline = 0, storageOK = false;
  const readDeadline = (start = false) => {
    try {
      let stored = localStorage.getItem(storageKey);
      if (!stored && start) { stored = String(Date.now() + duration); localStorage.setItem(storageKey, stored); }
      const value = Number(stored);
      deadline = Number.isSafeInteger(value) && value > 0 && value <= Date.now() + duration ? value : 0;
      storageOK = Boolean(stored && deadline);
    } catch (_) { deadline = 0; storageOK = false; }
  };
  readDeadline(config.landing === true);
  let currentCart = {items:[],attributes:config.attributes || {}}, cartEligible = config.eligible === true, work, revision = 0;
  const claimValid = attributes => {
    const end = Date.parse(attributes?.[deadlineKey] || ''), claimedAt = Date.parse(attributes?.[claimKey] || '');
    return attributes?.[config.attribute] === config.value && Number.isFinite(end) && Number.isFinite(claimedAt) && claimedAt <= end && claimedAt >= end - duration;
  };
  let claimed = cartEligible && claimValid(currentCart.attributes);
  const active = () => storageOK && Date.now() < deadline;
  const paint = () => {
    const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    const time = `${String(Math.floor(seconds / 60)).padStart(2,'0')}:${String(seconds % 60).padStart(2,'0')}`;
    document.querySelectorAll('[data-kr-gift-card]').forEach(card => {
      const eligible = card.dataset.krGiftScope === 'cart' ? cartEligible : true;
      card.hidden = !eligible || (!active() && !claimed);
      card.querySelectorAll('[data-kr-gift-time]').forEach(value => { value.textContent = time; });
      card.querySelectorAll('[data-kr-gift-countdown]').forEach(row => { row.hidden = claimed; });
      card.querySelectorAll('[data-kr-gift-claimed]').forEach(row => { row.hidden = !claimed; });
    });
    document.querySelectorAll('[data-kr-gift-accelerated]').forEach(row => { row.hidden = cartEligible && active() && !claimed; });
    document.querySelectorAll('[data-kr-cart-gift-attribute]').forEach(input => { input.value = claimed ? config.value : ''; });
  };
  const request = async (url, init = {}) => {
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 7000);
    try {
      const response = await fetch(url,{credentials:'same-origin',cache:'no-store',...init,signal:controller.signal,headers:{Accept:'application/json',...init.headers}});
      if (!response.ok) throw new Error('Gift sync unavailable');
      const result = await response.json();
      if (!Array.isArray(result.items)) throw new Error('Invalid cart');
      return result;
    } finally { clearTimeout(timeout); }
  };
  const accept = cart => { currentCart = cart; cartEligible = qualifies(cart); claimed = cartEligible && claimValid(cart.attributes); paint(); };
  const emptyAttributes = () => ({[config.attribute]:'',[deadlineKey]:'',[claimKey]:''});
  const reconcile = () => {
    revision++;
    if (work) return work;
    work = (async () => {
      let seen;
      do {
        seen = revision;
        const cart = await request(cartUrl.href);
        if (seen !== revision) continue;
        accept(cart);
        if (!claimed && Object.keys(emptyAttributes()).some(key => cart.attributes?.[key])) {
          const result = await request(updateUrl.href,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:emptyAttributes()})});
          if (seen === revision) accept(result);
        }
      } while (seen !== revision);
    })().finally(() => { work = null; });
    return work;
  };
  const allowed = new WeakSet(), pending = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target, button = event.submitter;
    if (!(form instanceof HTMLFormElement) || (button?.name !== 'checkout' && !form.classList.contains('kr-cart-confirmation__checkout-form'))) return;
    if (allowed.has(form)) { allowed.delete(form); return; }
    event.preventDefault();
    if (pending.has(form)) return;
    pending.add(form);
    const clickedAt = Date.now(), clickedInTime = storageOK && clickedAt < deadline;
    if (button) button.setAttribute('aria-busy','true');
    try {
      if (work) await work.catch(() => {});
      try { accept(await request(cartUrl.href)); } catch (_) { /* Native checkout carries the last known cart eligibility. */ }
      let attributes = emptyAttributes();
      if (cartEligible && (claimed || clickedInTime)) {
        attributes = {
          [config.attribute]:config.value,
          [deadlineKey]:claimed ? currentCart.attributes[deadlineKey] : new Date(deadline).toISOString(),
          [claimKey]:claimed ? currentCart.attributes[claimKey] : new Date(clickedAt).toISOString(),
        };
      }
      for (const [key,value] of Object.entries(attributes)) {
        [...form.elements].filter(input => input.name === `attributes[${key}]`).forEach(input => input.remove());
        const input = document.createElement('input'); input.type='hidden'; input.name=`attributes[${key}]`; input.value=value; form.append(input);
      }
      allowed.add(form);
      form.requestSubmit(button || undefined);
    } finally { pending.delete(form); if (button) button.removeAttribute('aria-busy'); }
  }, true);
  window.krOrderGift = {reconcile, qualifies};
  document.addEventListener('kr:cart-updated', event => { if (event.detail?.cart) accept(event.detail.cart); reconcile().catch(() => {}); });
  document.addEventListener('shopify:cart:lines-update', event => { if (event.promise) event.promise.then(() => reconcile()).catch(() => {}); });
  window.addEventListener('storage', event => { if (event.key === storageKey) { readDeadline(); paint(); } });
  window.addEventListener('pageshow', event => { if (event.persisted) { readDeadline(); reconcile().catch(() => {}); } });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { readDeadline(); paint(); } });
  paint();
  setInterval(paint,1000);
  if (!claimed && Object.keys(emptyAttributes()).some(key => config.attributes?.[key])) reconcile().catch(() => {});
})();
